import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function HookSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-dark-section py-20 md:py-28" data-id="element-144">
      <motion.div className="max-w-3xl mx-auto px-6" initial={{
      opacity: 0,
      y: 40
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 40
    }} transition={{
      duration: 0.7,
      ease: [0.25, 0.46, 0.45, 0.94]
    }} data-id="element-145">
        {/* Opening narrative */}
        <div className="relative" data-id="element-146">
          {/* Large quote mark */}
          <span className="absolute -top-8 -left-4 text-8xl text-orange-accent/10 font-bebas select-none" data-id="element-147">
            "
          </span>

          <p className="font-inter text-xl md:text-2xl text-concrete leading-relaxed mb-8 relative z-10" data-id="element-148">
            The delivery truck pulls into your driveway. Two guys in neon vests
            lug a 600lb steel box into your garage.{' '}
            <span className="text-white" data-id="element-149">
              Every neighbor on the block just got a front-row seat
            </span>{' '}
            to the fact that you own five figures worth of hardware.
          </p>

          <p className="font-inter text-lg md:text-xl text-concrete leading-relaxed mb-10" data-id="element-150">
            You think you bought security. In reality, you just put a neon{' '}
            <span className="text-orange-accent font-semibold" data-id="element-151">'Vegas'</span>{' '}
            sign on your house for every local meth-head and professional thief.
          </p>

          <p className="font-inter text-lg md:text-xl text-concrete leading-relaxed mb-10" data-id="element-152">
            If a burglar has 10 minutes and a $40 cordless grinder, he owns
            everything inside that "safe."
          </p>
        </div>

        {/* Bold callout */}
        <motion.div className="border-l-4 border-orange-accent pl-6 py-4 bg-dark-card/50" initial={{
        opacity: 0,
        x: -20
      }} animate={isInView ? {
        opacity: 1,
        x: 0
      } : {
        opacity: 0,
        x: -20
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} data-id="element-153">
          <p className="font-inter text-xl md:text-2xl text-white font-medium leading-relaxed" data-id="element-154">
            But what if he spends two hours in your house and{' '}
            <span className="text-orange-accent" data-id="element-155">never even realizes</span> he's
            standing directly on top of your entire collection?
          </p>
        </motion.div>
      </motion.div>
    </section>;
}